import { t } from '@app/i18n';

/**
 * Validação do campo de limite (FR-073): número ≥ 0, até 2 casas decimais,
 * **vazio = sem teto**.
 *
 * O erro é inline no campo; o rodapé não deixa salvar enquanto houver um.
 */

const LIMIT = /^\d+([.,]\d{1,2})?$/;

/** Função, não const: a mensagem tem de sair no idioma de quem valida. */
export const errorLimit = (): string => t('identityAccess.validation.limit');

export function validateLimit(valor: string): string | null {
  const texto = valor.trim();
  if (!texto) return null;
  if (!LIMIT.test(texto)) return errorLimit();
  return Number(texto.replace(',', '.')) >= 0 ? null : errorLimit();
}

/** `'50,25'` → `50.25`; vazio → `undefined` (sem teto). */
export function limitForNumber(valor: string): number | undefined {
  const texto = valor.trim();
  if (!texto) return undefined;
  const num = Number(texto.replace(',', '.'));
  return Number.isFinite(num) ? num : undefined;
}
